module.exports = __webpack_public_path__ + "img/BasementBadlands.06bef77b.png";